import React from 'react';
import { Content, Flex } from '@leverege/ui-elements';
import { TitleBar, Toolbar } from '@leverege/ui-plugin';
import { Attributes } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import SplitPane from 'split-pane-react';
import ViewerModel from "../../dataViewers/layout/ViewerModel.js";
import LoadingScreen from "../support/LoadingScreen.js";
import { ItemInfoDataViewers as DataViewers } from "../../dataViewers/DataViewers.js";
import Blocker from "../../views/blocker/Blocker.js";
import { rdvm, rhdv } from "../../dataViewers/Util.js";
import AbstractItemInfoScreen, { connectChild } from "./AbstractItemInfoScreen.js";
import S from './DesktopItemInfoScreen.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.screens.itemInfo.DesktopItemInfoScreen');
class DesktopItemInfoScreen extends AbstractItemInfoScreen {
  constructor(props) {
    super(props);
    this.toolbarMatchContext = {
      ...this.matchContext,
      use: 'actionBar'
    };
    this.layoutToolbarMatchContext = {
      ...this.matchContext,
      use: 'layoutActionBar'
    };
    const {
      settingsPath
    } = props;
    const splitPaneSizes = localStorage.getItem(`${settingsPath}.splitPaneSizes`);
    this.state = {
      splitPaneSizes: splitPaneSizes ? JSON.parse(splitPaneSizes) : ['50%', '50%']
    };
  }
  onChangeSplitSize = sizes => {
    const {
      settingsPath
    } = this.props;
    localStorage.setItem(`${settingsPath}.splitPaneSizes`, JSON.stringify(sizes));
    this.setState({
      splitPaneSizes: sizes
    });
  };
  render() {
    return /*#__PURE__*/_jsx(Blocker, {
      matchContext: this.matchContext,
      context: this.props,
      render: this.renderChildren
    });
  }
  renderChildren = () => {
    const {
      nameAttr = 'name',
      iconAttr = 'icon',
      title: pTitle,
      icon: pIcon,
      item,
      relationship,
      settings,
      settingsPath
    } = this.props;
    const {
      modifiedLayout,
      splitPaneSizes
    } = this.state;
    const currLayout = modifiedLayout || settings || {};
    const {
      layout = 'vh',
      main1,
      main2,
      aux1,
      aux2,
      aux3,
      aux4
    } = currLayout;
    const mainVertical = layout[1] === 'v';
    const {
      objectType
    } = relationship;
    const loading = false;
    if (item == null) {
      if (loading) {
        return /*#__PURE__*/_jsx(LoadingScreen, {
          title: t('loading')
        });
      }
    }
    const dataItems = this.cache.calc('items', this.createDataItems, item);
    this.paginator.setData(dataItems);
    const name = pTitle || Attributes.get(nameAttr, objectType, item) || relationship.name;
    const icon = pIcon || Attributes.get(iconAttr, objectType, item);
    const dvp = this.getDataViewerProps(DataViewers);
    const gridTemplateAreas = this.cache.calc('layout', ViewerModel.createGridTemplate, currLayout);
    const hiddenDataViewers = this.getHiddenDataViewers();
    const cAux1 = rdvm(aux1, dvp, {
      settingsPath,
      settingsData: 'setAux1Settings',
      vertical: false
    });
    const cAux2 = rdvm(aux2, dvp, {
      settingsPath,
      settingsData: 'setAux2Settings',
      vertical: false
    });
    const cAux3 = rdvm(aux3, dvp, {
      settingsPath,
      settingsData: 'setAux3Settings',
      vertical: true
    });
    const cAux4 = rdvm(aux4, dvp, {
      settingsPath,
      settingsData: 'setAux4Settings',
      vertical: true
    });
    const cMain1 = rdvm(main1, dvp, {
      settingsPath,
      settingsData: 'setMain1Settings'
    });
    const cMain2 = rdvm(main2, dvp, {
      settingsPath,
      settingsData: 'setMain2Settings'
    });
    const hasSplit = cMain1 && cMain2;
    const cxt = this.getContext();
    return /*#__PURE__*/_jsxs(Content, {
      children: [/*#__PURE__*/_jsx(Content.Header, {
        children: /*#__PURE__*/_jsxs(TitleBar, {
          variant: "screenTitle",
          title: name,
          icon: icon,
          children: [/*#__PURE__*/_jsx(Toolbar, {
            variant: "actionBar",
            hasContextMenu: true,
            prefer: "icon",
            matchContext: this.toolbarMatchContext,
            context: cxt
          }), /*#__PURE__*/_jsx(Flex, {
            align: "center",
            children: /*#__PURE__*/_jsx(Toolbar, {
              variant: "layoutActionBar|actionBar",
              prefer: "icon",
              matchContext: this.layoutToolbarMatchContext,
              mustMatchContext: {
                use: 'layoutActionBar'
              },
              context: cxt
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        children: /*#__PURE__*/_jsxs("div", {
          className: S.grid,
          style: {
            '--grid': gridTemplateAreas
          },
          children: [aux1 && /*#__PURE__*/_jsx("div", {
            className: S.aux1,
            children: cAux1
          }), aux2 && /*#__PURE__*/_jsx("div", {
            className: S.aux2,
            children: cAux2
          }), aux3 && /*#__PURE__*/_jsx("div", {
            className: S.aux3,
            children: cAux3
          }), aux4 && /*#__PURE__*/_jsx("div", {
            className: S.aux4,
            children: cAux4
          }), /*#__PURE__*/_jsx("div", {
            className: S.main,
            children: /*#__PURE__*/_jsxs(SplitPane, {
              allowResize: hasSplit,
              resizerSize: hasSplit ? 4 : 0,
              sizes: hasSplit ? splitPaneSizes : [main1 ? '100%' : 0, main2 ? '100%' : 0],
              onChange: this.onChangeSplitSize,
              split: !mainVertical ? 'vertical' : 'horizontal',
              children: [cMain1 || /*#__PURE__*/_jsx("div", {}), cMain2 || /*#__PURE__*/_jsx("div", {})]
            })
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: S.hiddenDataViewers,
        children: hiddenDataViewers.map(dataViewer => rhdv(dataViewer, dvp))
      })]
    });
  };
}
export default connectChild(DesktopItemInfoScreen, {
  clientType: 'DesktopItemInfoScreen'
}, ViewerModel);